
import { AllLabels } from '@/interfaces';
import { labelsStore } from '@/store';
import { Component, Vue } from 'vue-property-decorator';
import Footer from '@/components/common/Footer.vue';
import SelectCasePageContent from './SelectCasePageContent.vue';


@Component({
  components: {
    Footer,
    SelectCasePageContent,
  }
})
export default class SelectCasePage extends Vue {

  public get labels(): AllLabels {
    return labelsStore.labels;
  }
}

